import React, { useState } from "react";
import { gaTrackCta } from "../../../analytics/ga4";
import { C } from "../../../core/constants";
import { APP_FONT_SIZE } from "../../../core/theme";
import { getPredictionReplayTarget, PREDICTION_FEATURE_META } from "../readingReplay";

export default function ReadingReplayListItem({
  item,
  isLast,
  acc,
  t,
  locale,
  formatInTimezone,
  setPage,
  screenClass,
  ctaIdPrefix,
  variant = "compact",
  ctaLabelKey = "dashboard_recent_readings_open_cta",
}) {
  const fs = APP_FONT_SIZE;
  const [hovered, setHovered] = useState(false);
  const { replayable, targetPage } = getPredictionReplayTarget(item);
  const meta = PREDICTION_FEATURE_META[item?.feature] || { icon: "◎", accent: "primary" };
  const accentColor = acc[meta.accent] || acc.primary;
  const isHistory = variant === "history";

  const openReading = () => {
    if (!replayable) return;
    gaTrackCta({
      cta_id: `${ctaIdPrefix}_${item?.feature || "reading"}`,
      cta_label: item.feature_label,
      destination: targetPage,
      screen_class: screenClass,
    });
    setPage(targetPage, { query: { replay: "1", predictionId: String(item.prediction_id) } });
  };

  if (isHistory) {
    return (
      <button
        type="button"
        onClick={openReading}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: "100%",
          border: `1px solid ${hovered && replayable ? `${accentColor}55` : "rgba(255,255,255,0.08)"}`,
          background: hovered && replayable ? `${accentColor}10` : "rgba(255,255,255,0.03)",
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          gap: 14,
          padding: "14px 16px",
          borderRadius: 14,
          marginBottom: isLast ? 0 : 10,
          cursor: replayable ? "pointer" : "default",
          opacity: replayable ? 1 : 0.7,
          transition: "all 0.2s ease",
          transform: hovered && replayable ? "translateY(-1px)" : "none",
        }}
      >
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 12,
            flexShrink: 0,
            display: "grid",
            placeItems: "center",
            fontSize: 20,
            color: accentColor,
            background: `${accentColor}18`,
            border: `1px solid ${accentColor}33`,
            boxShadow: hovered && replayable ? `0 0 18px ${accentColor}33` : "none",
          }}
          aria-hidden
        >
          {meta.icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ color: C.textPrimary, fontSize: fs - 1, fontWeight: 500, marginBottom: 3 }}>
            {item.feature_label}
          </div>
          <div style={{ color: C.textMuted, fontSize: 12 }}>
            {formatInTimezone(item.created_at, { locale, dateStyle: "medium", timeStyle: "short" })}
          </div>
        </div>
        {replayable ? (
          <span
            style={{
              color: accentColor,
              fontSize: 12,
              fontWeight: 500,
              letterSpacing: "0.04em",
              whiteSpace: "nowrap",
            }}
          >
            {t(ctaLabelKey)} →
          </span>
        ) : (
          <span style={{ color: C.textMuted, fontSize: 12 }}>—</span>
        )}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={openReading}
      style={{
        width: "100%",
        border: "none",
        background: replayable ? "rgba(255,255,255,0.03)" : "transparent",
        textAlign: "left",
        display: "flex",
        justifyContent: "space-between",
        gap: 10,
        padding: "10px 12px",
        borderRadius: 10,
        borderBottom: isLast ? "none" : "1px solid rgba(255,255,255,0.06)",
        cursor: replayable ? "pointer" : "default",
        opacity: replayable ? 1 : 0.75,
        transition: "all 0.2s ease",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <span style={{ color: C.textPrimary, fontSize: fs - 2 }}>{item.feature_label}</span>
        <span style={{ color: C.textMuted, fontSize: 11 }}>
          {formatInTimezone(item.created_at, { locale, dateStyle: "medium", timeStyle: "short" })}
        </span>
      </div>
      {replayable ? (
        <span
          style={{
            color: acc.primary,
            fontSize: 11,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            border: `1px solid ${acc.primary}55`,
            borderRadius: 999,
            padding: "4px 10px",
            alignSelf: "center",
            whiteSpace: "nowrap",
          }}
        >
          {t(ctaLabelKey)}
        </span>
      ) : (
        <span style={{ color: C.textMuted, fontSize: 12, alignSelf: "center" }}>—</span>
      )}
    </button>
  );
}
